import {
  ADD_SPACE_TAG,
  CHECK_ALL_SPACE,
  CHECK_SPACE,
  DELETE_SPACES,
  DELETE_SPACE_TAG,
  FILTER_SPACE,
  SET_LEGAL_CAPACITY,
  SET_SAFE_CAPACITY,
  SET_SPACES,
  SET_TARGET_CAPACITY,
  SpacesAction,
} from "../types";

// import the dependency
import { Space } from "../../types";

const initialState: Space[] = [];

export default (state: Space[] = initialState, action: SpacesAction) => {
  switch (action.type) {
    case SET_SPACES:
      let newTags = action.payload;
      action.payload.map((newSpace: Space) => {
        for (let space of state) {
          if (newSpace.id === space.id) {
            newSpace.selected = space.selected;
            newSpace.filtered = space.filtered;
            break;
          }
        }
      });
      return Object.assign(newTags);
    case CHECK_SPACE:
      return state.map((space: Space) => {
        return action.payload.id === space.id
          ? { ...space, selected: action.payload.selected }
          : space;
      });
    case FILTER_SPACE:
      return state.map((space: Space) => {
        return action.payload.id === space.id
          ? { ...space, selected: action.payload.filtered }
          : space;
      });
    case CHECK_ALL_SPACE:
      return state.map((space: Space) => {
        return { ...space, selected: action.payload };
      });

    case DELETE_SPACES:
      return [];

    case ADD_SPACE_TAG:
      return state.map((space: Space) => {
        if (action.payload.id === space.id) {
          space.tags.push(action.payload.tag);
        }
        return space;
      });

    case DELETE_SPACE_TAG:
      return state.map((space: Space) => {
        let newSpace = space;
        if (action.payload.id === space.id) {
          var index = newSpace.tags.indexOf(action.payload.tag);
          if (index !== -1) {
            newSpace.tags.splice(index, 1);
          }
        }
        return newSpace;
      });

    case SET_SAFE_CAPACITY:
      return state.map((space: Space) => {
        let newSpace = space;
        if (space.id === action.payload.id) {
          newSpace.safe_capacity = action.payload.capacity;
        }
        return newSpace;
      });

    case SET_TARGET_CAPACITY:
      return state.map((space: Space) => {
        let newSpace = space;
        if (space.id === action.payload.id) {
          newSpace.target_capacity = action.payload.capacity;
        }
        return newSpace;
      });

    case SET_LEGAL_CAPACITY:
      return state.map((space: Space) => {
        let newSpace = space;
        if (space.id === action.payload.id) {
          newSpace.capacity = action.payload.capacity;
        }
        return newSpace;
      });

    default:
      return state;
  }
};
